export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/inspection_points.61c92b6a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};